import { defineMessages } from 'react-intl';

export default defineMessages({
  shipStationBalance: {
    description: 'Informational title header for a given wallet fund balance',
    defaultMessage: 'ShipStation Balance',
    id: 'yyZmSQ',
  },
  subText: {
    description: 'Informational subtext on what a given wallet fund balance can pay for',
    defaultMessage: 'Pay for Labels, Insurance and other fees',
    id: 'fnJzhy',
  },
  insuffcientFundsError: {
    description: 'Error message when a wallet fund balance is lower than an amount needed for purchase',
    defaultMessage: 'Insufficient Funds for Purchase',
    id: 'F/+ltI',
  },
  addFundsButton: {
    defaultMessage: 'Add Funds',
    id: 'eg89ip',
    description: 'Text prompt to add money to balance',
  },
  manageFundsButton: {
    defaultMessage: 'Manage Funds',
    id: '/MZN+F',
    description: 'Text prompt to open manage funds dropdown',
  },
  manageAutoFunding: {
    defaultMessage: 'Manage Auto Funding',
    id: 'NV61Wq',
    description: 'dropdown item for opening auto funding modal',
  },
  registerWallet: {
    defaultMessage: 'You will be prompted to add payment details before adding funds.',
    id: '/GOLQ3',
    description: 'Tooltip message for add funds link if the user has not registered their wallet',
  },
});
